// src/services/permissionParser.ts

export function parseRoleData(role: any) {
  if (!role?.roleMenus) {
    return {
      menus: [],
      actionIds: [],
      actionCodes: [],
      scopedActionCodes: [],
    };
  }

  const menus: any[] = [];
  const actionIds: number[] = [];
  const actionCodes: string[] = [];
  const scopedActionCodes: string[] = [];

  const normalizeMenuKey = (menu: any): string => {
    const raw = String(menu?.path || menu?.title || menu?.name || '').trim();
    const noSlash = raw.replace(/^\/+|\/+$/g, '');
    return noSlash.toLowerCase();
  };

  const normalizeActionCode = (actionCode: any): string => {
    const raw = String(actionCode || '').trim().toLowerCase();
    // 兼容后端把 actionCode 存成 /edit /submit /view 的情况
    return raw.replace(/^\/+/, '');
  };

  role.roleMenus.forEach((rm: any) => {
    const menu = rm?.menu;
    if (!menu || menu.isHidden) return;

    menus.push(menu);
    const menuKey = normalizeMenuKey(menu);

    if (Array.isArray(menu.actions)) {
      menu.actions.forEach((action: any) => {
        const hasPermission =
          Array.isArray(action.roleActions) &&
          action.roleActions.some(
            // 用 String() 转换避免数字/字符串类型不一致导致 === 匹配失败
            (ra: any) => String(ra.roleId) === String(role.id)
          );

        if (hasPermission) {
          const normalizedActionCode = normalizeActionCode(action.actionCode);
          if (!normalizedActionCode) return;

          actionIds.push(action.id);
          actionCodes.push(normalizedActionCode);

          if (menuKey) {
            scopedActionCodes.push(`${menuKey}:${normalizedActionCode}`);
          }
        }
      });
    }
  });

  return {
    menus,
    actionIds: Array.from(new Set(actionIds)),
    actionCodes: Array.from(new Set(actionCodes)),
    scopedActionCodes: Array.from(new Set(scopedActionCodes)),
  };
}
